<ng-container>
  <ul class="nav-list-mobile" *ngIf="visible" [attr.id]="idPanel">
    <li class="header-menu" *ngIf="showContent">
      <button
        mat-mini-fab
        [attr.id]="'back-' + idPanel"
        aria-label="Retour menu principal"
        (click)="toggle()"
      >
        <mat-icon aria-hidden="true">chevron_left</mat-icon>
      </button>
      <span class="header-menu-title" translate>{{ labelRetour }}</span>
    </li>
    <ng-container *ngFor="let item of items; let i = index">
      <li class="item-menu-mobile" *ngIf="showContent">
        <button
          *ngIf="item.children === undefined"
          mat-button
          routerLink="{{ item.routerLink | translate }}"
          (click)="onSidenavClose(this)"
        >
          <span translate>{{ item.label }}</span>
        </button>
        <button
          *ngIf="item.children !== undefined && item.children.length"
          mat-button
          class="subMenu"
          [attr.aria-expanded]="idPanelCourant === item.idPanel ? 'true' : 'false'"
          [attr.aria-controls]="item.idPanel"
          (click)="showPanel(item.idPanel)"
        >
          <span translate>{{ item.label }}</span>
        </button>
      </li>

      <app-menu-panel-mobile
        #menuChildren
        *ngIf="item.children !== undefined && item.children.length"
        [idPanel]="item.idPanel"
        [labelRetour]="item.label"
        [items]="item.children"
        [visible]="false"
        (sidenavClose)="onSidenavClose(this)"
        (closePanel)="toggleChildren()"
      ></app-menu-panel-mobile>
    </ng-container>
  </ul>
</ng-container>
